import { AppBar, Body, PageLayout } from 'components/common';
import SettingList from 'components/SettingList';

const PageAbout: React.FC = () => {
  const handleLinkClick = (title: string, url: string): void => {
    Transition.showPage(Def.PAGE_IFRAME, { title, url });
  };

  const handleContactUsClick = () => {
    const recipient = 'appbermuda@gmail.com';
    const subject = '[Inquiry] ';
    const body = '*Please provide the following details:\n';
    const bodySignature = `- Inquiry: \n- Device model: \n- Account: ${myinfo.fbUid}\n`;

    const format = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body + bodySignature)}`;
    const encodedUrl = format.replaceAll(' ', '%20').replaceAll('\n', '%0D%0A');

    Device.openURL(encodedUrl);
  };

  const locale = BResource.getSelectedLocale();
  const isKo = locale === 'ko';
  const cgTitle = isKo ? '커뮤니티 규칙' : 'Community Rules';
  const cgHtml = isKo ? 'communityguide-ko.html' : 'communityguide-en-us.html';
  const cpasTitle = isKo ? '아동 보호 및 안전' : 'Child Protection and Safety';
  const cpasHtml = isKo ? 'childprotectionandsafety-ko.html' : 'childprotectionandsafety-en-us.html';
  const ppTitle = isKo ? '개인정보 처리방침' : 'Privacy Policy';
  const ppHtml = isKo ? 'privacypolicy-ko.html' : 'privacypolicy.html';
  const tolTitle = '위치기반서비스 이용약관';
  const tolHtml = 'termsoflocation-ko.html';

  const isCookieHide = !ConsentManager.checkVisibleInAboutPage();

  const getVersionName = (version: string): string => {
    const matched = /\d+(?:\.\d+)+/.exec(version);
    if (!matched) {
      BLog.warn('Unexpected app version format:', version);
      return version;
    }
    return matched[0];
  };

  const getServerVersion = (): string => {
    const version = BResource.getVersion();
    const host = window.location.host;
    let server = '';

    if (host === 'staging.thebermuda.net') {
      server = '/stg';
    } else if (host === 'dev.gobermuda.net' || host === 'dev.thebermuda.net') {
      server = '/dev';
    } else if (host.startsWith('bgrok.thebermuda.net')) {
      server = '/local';
    }
    return getVersionName(version) + '/' + WEB_VERSION + server;
  };

  return (
    <PageLayout>
      <AppBar title={brsc.about_title} />
      <Body className="flex flex-col pb-[30px] pt-[20px]">
        <div className="flex flex-col items-center px-5">
          <img className="h-[4.5rem] w-[4.5rem] p-1" alt="logo" src="/imgweb/main/logo_flat.svg" />
          <div className="my-6 text-sm"> {brsc.about_detail} </div>
        </div>
        <SettingList text="Contact" icon="email" onClick={handleContactUsClick} />
        <SettingList text="Open Source Licenses" icon="page" onClick={() => handleLinkClick('Open Source Licenses', '/credits.html')} />
        <SettingList text="Terms of Service" icon="page" onClick={() => handleLinkClick('Terms of Service', 'https://www.thebermuda.net/termsofservice.html')} />
        <SettingList text={cgTitle} icon="page" onClick={() => handleLinkClick(cgTitle, `https://www.thebermuda.net/${cgHtml}`)} />
        <SettingList text={cpasTitle} icon="page" onClick={() => handleLinkClick(cpasTitle, `https://www.thebermuda.net/${cpasHtml}`)} />
        {isKo && <SettingList text={tolTitle} icon="page" onClick={() => handleLinkClick(tolTitle, `https://www.thebermuda.net/${tolHtml}`)} />}
        <SettingList text={ppTitle} icon="page" onClick={() => handleLinkClick(ppTitle, `https://www.thebermuda.net/${ppHtml}`)} />
        <SettingList text="Cookies" onClick={() => ConsentManager.showBanner()} hide={isCookieHide} />
        <div className="relative min-h-[120px] flex-1">
          <div className="absolute bottom-0 left-0 w-full px-12">
            <div className="typography-caption-body mx-auto w-fit max-w-full break-words rounded-lg bg-base-bg-subtle px-5 py-2 text-center">{getServerVersion()}</div>
          </div>
        </div>
      </Body>
    </PageLayout>
  );
};

export default PageAbout;
